module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startedQuiz === false),
      expression: "startedQuiz === false"
    }],
    key: "intro",
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "intro"
  }, [_c('div', {
    staticClass: "intro-inner"
  }, [_c('h1', [_vm._v("Chemical Reactions and Stoichiometry")]), _vm._v(" "), _c('p', [_vm._v("Classify each chemical reaction, then balance the equation and solve a stoichiometry question based on it.")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.startedQuiz = true
      }
    }
  }, [_vm._v("Begin Quiz")])])])]), _vm._v(" "), _c('quiz', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startedQuiz === true),
      expression: "startedQuiz === true"
    }],
    key: "quizComponent",
    attrs: {
      "questions": _vm.questions
    },
    on: {
      "restartQuiz": function($event) {
        _vm.startedQuiz = false
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46e77a74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 70
// module chunks = 1